
<template>

	<mymodal ref="modal" :title="'Добавить расчет для группы: ' + group_full_name" ok="Применить" :reset="reset" :check="check" :submit="submit">

		<b-form-checkbox-group v-model="selected" stacked>

			<b-form-checkbox v-for="approach in approaches" :key="approach.type" :value="approach.type" :disabled="approach.disabled">

				{{ approach.label }}

			</b-form-checkbox>

		</b-form-checkbox-group>

	</mymodal>

</template>

<script>

import api from "../../../api"
import mymodal from "../../widgets/modal"

export default
{
	props :
	{
		group_id : String,
		group_full_name : String,
		group : Object,
	},

	components:
	{
		mymodal,
	},

	data()
	{
		var approaches = 
			[
				{ type: "Сравнительный подход", label: "Сравнительный (Метод статистического (регрессионного) моделирования)" },
			]

		if(api.has_oks())
			approaches.push({ type: "Затратный подход", label: "Затратный (Метод сравнительной единицы)" })

		approaches.push({ type: "Доходный подход", label: "Доходный (Метод прямой капитализации)" })

		return {

			service : "cadastral_groups",

			selected : [],
			without : [],

			approaches : approaches,

		}
	},

	watch :
	{
		group_id :
		{
			immediate : true,

			handler(group_id)
			{
				if(group_id)
				{
					this.group_id = group_id

					this.refresh()
				}
			}
		}
	},

	methods:
	{
		check()
		{
			return this.selected.filter(type => this.without.find(_type => type == _type) == null).length != 0
		},

		refresh(group_id = null)
		{
			if(group_id == null)
				group_id = this.group_id

			api.call(this, this.service, "get", { id : group_id },
				response =>
				{
					this.selected = []
					this.without = []
					
					var key = "Сравнительный подход"
					var approach = this.approaches.find(desc => desc.type == key)

					if(response.data.cost_evaluation_comparative)
					{
						this.selected.push(approach.type)
						this.without.push(approach.type)

						approach.disabled = true
					}
					else
						approach.disabled = false

					key = "Затратный подход"
					approach = this.approaches.find(desc => desc.type == key)

					if(approach)
					{
						if(response.data.cost_evaluation_expensive)
						{
							this.selected.push(approach.type)
							this.without.push(approach.type)

							approach.disabled = true
						}
						else
							approach.disabled = false
					}

					key = "Доходный подход"
					approach = this.approaches.find(desc => desc.type == key)

					if(response.data.cost_evaluation_profitable)
					{
						this.selected.push(approach.type)
						this.without.push(approach.type)

						approach.disabled = true
					}
					else
						approach.disabled = false
				})
		},

		reset()
		{
		},

		execute()
		{
			this.refresh(this.group.id)
			this.$refs.modal.execute()
		},

		submit()
		{
			api.call(this, this.service, "create_cost_evaluation", { id : this.group_id, calculation_types : this.selected }, () => this.$emit("need_refresh", this.selected))
		}
	}
}

</script>

